import React from "react";
import { useLocation } from "react-router-dom";
import { usePageActivity } from "Components/Hooks/UsePageActivity";
import { Container } from "reactstrap";
import BreadCrumb from "Components/Common/BreadCrumb";
import AllLogs from "./AllLogs";

const ActivityLogs = () => {
  const location = useLocation();
  usePageActivity(location.pathname, "Activity Logs");

  document.title = "Activity Logs | CIMS";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Activity Logs"
            pageTitles={[
              { title: "Dashboard", link: "/dashboard" },
              { title: "User Activity", link: "#" },
            ]}
          />

          <AllLogs />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ActivityLogs;
